// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"radio_wrapper__2fdpF","label":"radio_label__2VEI8","radio":"radio_radio__2D28_"};